import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '../../assets//plattegrond_bazaar_2023_small.webp'
import _imports_1 from '../../assets//plattegrond_bazaar_2023.webp'


import { ref } from 'vue';
import CrossIcon from '../icons/CrossIcon.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Map',
  setup(__props) {

const fullSize = ref<boolean>(false);

const showMap = () => {
  fullSize.value = true;
};

const hideMap = () => {
  fullSize.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("a", {
      href: "#",
      onClick: _withModifiers(showMap, ["prevent"])
    }, _cache[0] || (_cache[0] = [
      _createElementVNode("img", {
        alt: "Bazaar Plattegrond",
        src: _imports_0
      }, null, -1)
    ])),
    (fullSize.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fullsize-map",
          onClick: _withModifiers(hideMap, ["prevent"])
        }, [
          _cache[1] || (_cache[1] = _createElementVNode("img", {
            alt: "Bazaar Plattegrond",
            src: _imports_1
          }, null, -1)),
          _createElementVNode("button", {
            class: "option icon small",
            onClick: hideMap
          }, [
            _createVNode(CrossIcon, {
              size: 10,
              fill: "white"
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})